import { Radio } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const StyledRadio = styled(Radio)`
  > div {
    font-size: 13px;
  }
`;
